import TextField from "../TextField";
import Skipper from "./Skipper";

export default function NumberSelector({
  padding,
  number,
  setNumber,
  interval,
  title,
  backgroundColor,
}: {
  padding: string | null;
  number: number;
  setNumber: Function;
  interval: number;
  title: string | undefined;
  backgroundColor: string | undefined;
}) {
  const add = () => {
    setNumber(Number(number) + interval);
  };
  const substract = () => {
    if (Number(number) - interval < 0) {
      setNumber(0);
    } else {
      setNumber(Number(number) - interval);
    }
  };
  return (
    <div style={{ padding: padding ?? "0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <Skipper
          backgroundColor={backgroundColor}
          icon="--"
          onClick={substract}
        />
        <TextField
          backgroundColor={backgroundColor}
          contentSize={"30px"}
          contentWeight={"bold"}
          contentPosition={"center"}
          maxLength={undefined}
          padding={undefined}
          placeHolder=""
          setText={setNumber}
          text={number.toString()}
          title={undefined}
          type={"number"}
        />
        <Skipper backgroundColor={backgroundColor} icon="+" onClick={add} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          fontSize: "20px",
          fontWeight: "500",
        }}
      >
        {title}
      </div>
    </div>
  );
}
